<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">设置事件监听</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			对一些事件状态信息进行监听，不同的事件对应不同的参数。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"> public boolean SKFaceRegisterEvent(SKFaceEnum.PersonEvent EventName, Object EventCallback)
//事件监听枚举
public class SKFaceEnum {
    //监听Video人脸检测过程中的事件
    public static enum PersonEvent{
        PERSON_ENTER, // 有人进入
        NETWORK_DB_REGISTERD_PERSON_NUM //网络数据库已注册（可识别）人数
        //... ...
    }
}
//事件监听回调函数
//有人进入监听
public interface PersonEnterCallbackInterface {
    void PersonEnterCallback(String PersonEnterInfo);
}
//有人离开监听
public interface PersonLeaveCallbackInterface {
    void PersonLeaveCallback(String PersonLeaveInfo);
}
//网络数据库同步进度监听
public interface NetDBSyncProCallbackInterface {
    void NetDBSyncProCallback(int SyncPersonNum, int PersonTotal);
}
//网络数据库已注册（可识别）人数监听
public interface NetRegisteredPersonNumCallbackInterface {
    void NetRegisteredPersonNumCallback(int Num);
}</code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">
             <p class="doc_main_p">（1）EventName:需要设置的监听名称（SDK内部提供）</p>
              <p class="doc_main_p">（2）EventCallback:对应的监听回调函数（SDK内部提供）</p>         
        </p>
        <h3 class="doc_main_h3">返回值</h3><pre class="doc_main_pre"><code class="doc_main_code">（1）PersonEnterCallback(String PersonEnterInfo)：只针对认识的人、开启短时记忆的陌生人，json格式见下面
（2）PersonLeaveCallback(String PersonLeaveInfo)：只针对认识的人、开启短时记忆的陌生人，json格式见下面
（3）NetDBSyncProCallback(int SyncPersonNum, int PersonTotal)：
SyncPersonNum待同步数据中已同步人数，PersonTotal总人数
NetRegisteredPersonNumCallback(int Num)：网络数据库已注册（可识别）人数
（4）NetRegisteredPersonNumCallback(int Num)：网络数据库已注册（可识别）人数
               PersonEnterInfo/PersonLeaveInfo Json: 
{
    "Person_id":"161230",
    "Person_Name":"王某某",
    "Groups":[
        {
            "Group_id":"3910",
            "Group_Path":"注册人员（根目录）/盛开互动/"
        }
    ],
    "Person_HeadUrl":"http://skfrm.cn/Uploads/257871.jpg",
    "Age":27,
    "Gender":1,
    "Glasses":0,
    "AgeConfidence":0.99991,
    "GenderConfidence":0.99991,
    "GlassesConfidence":0.999881
}
{
    "Person_id":"L1000000",
    "Person_Name":"[00000001]",
    "Groups":[

    ],
    "Person_HeadUrl":"",
    "Age":2,
    "Gender":2,
    "Glasses":0,
    "AgeConfidence":0.910392,
    "GenderConfidence":0.910392,
    "GlassesConfidence":0.999646
}
字段含义：
{
    "Person_id": ID,
    "Person_Name": 姓名/陌生人（开启短时记忆）
    "Groups ": 所在人员组的id集合
Group_id：组id
Group_Path：路径
    "Person_HeadUrl": 大头照地址,
    "Age":年龄,
    "Gender":性别,
    "Glasses":眼镜状态,
    "AgeConfidence": 年龄置信度,
    "GenderConfidence": 性别置信度,
    "GlassesConfidence": 眼镜状态置信度
}</code></pre>        
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">//设置"有人进入"监听
skFace.SKFaceRegisterEvent(SKFaceEnum.PersonEvent.PERSON_ENTER, new 
PersonEnterCallbackInterface() {
    @Override
    public void PersonEnterCallback(String personEnterInfo) {
       
    }
});
//设置"有人离开"监听
skFaceSDKFamily.SKFaceRegisterEvent(SKFaceEnum.PersonEvent.PERSON_LEAVE, new PersonLeaveCallbackInterface() {
    @Override
    public void PersonLeaveCallback(String personLeaveInfo) {
       
    }
});
//设置“网络数据库同步进度”监听
skFaceSDKFamily.SKFaceRegisterEvent(SKFaceEnum.PersonEvent.NETWORK_DB_SYNC_PROGRESS, 
new NetDBSyncProCallbackInterface() {
    @Override
    public void NetDBSyncProCallback(int SyncPersonNum, int PersonTotal) {
        
    }
});
///设置"网络数据库已注册（可识别）人数"监听
skFaceSDKFamily.SKFaceRegisterEvent(SKFaceEnum.PersonEvent.NETWORK_DB_REGISTERD_PERSON_NUM, 
new NetRegisteredPersonNumCallbackInterface() {
    @Override
    public void NetRegisteredPersonNumCallback(int Num) {
        
    }
});</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceFamily-Android','视频接口','设置事件监听'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/SKFaceSDKFamily/voideinitiali/VoideSeetingmonitor.vue